import React from 'react'
import './about.css'
import ME from '../../assets/me-2.png'
import { FaAward } from 'react-icons/fa'
import { FiUsers } from 'react-icons/fi'
import { VscFolderLibrary } from 'react-icons/vsc'

const about = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className='about__me'>
          <div className="about__me-image">
            <img src={ME} alt="" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <FaAward className='about__icon' />
              <h5>Experience</h5>
              <small>3+ Years</small>
            </article>
            <article className='about__card'>
              <FiUsers className='about__icon' />
              <h5>Clients</h5>
              <small>Counting...</small>
            </article>
            <article className='about__card'>
              <VscFolderLibrary className='about__icon' />
              <h5>Projects</h5>
              <small>30+ Completed</small>
            </article>
          </div>
          <p>
          Hello! I'm iyanu, a front-end developer with experience in building 
          user interfaces for web applications using HTML, CSS, JavaScript.
          I have a good understanding of responsive design and i'm proficient in front-end frameworks 
          such as Bootstrap and React JS. I'm a highly motivated and detail-oriented individual with 
          excellent problem-solving skills, and i'm always looking to learn and stay up-to-date with the 
          latest front-end technologies and best practices.
          </p>
          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default about
